import { IAppComponent } from "./IAppComponent";
import { app } from "./App";

export class User {

    private button: HTMLElement;
    private popup: HTMLElement;

    /*
     * Initialize chat.
     */
    initialize(): void {
        this.button = document.getElementById("frameHeaderUser");
        this.popup = document.getElementById("framePopupUser");

        if (this.button) {
            this.button.addEventListener("click", (ev: MouseEvent) => {
                ev.cancelBubble = true;
                app.framePopup.toggle(this.popup);
            });
        }
    }
}
